export default __webpack_public_path__ + "static/media/167.e8dd85b2.gif";